import script from "./MProfileAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileAccount.vue?vue&type=script&setup=true&lang=js"

import "./MProfileAccount.vue?vue&type=style&index=0&id=f251aa8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f251aa8e"]])

export default __exports__